(ns frontend.view.grid.sale-agreements-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce sale-agreements (r/cursor app-db/views [:sale-agreements]))
(defonce modal-state (r/cursor sale-agreements [:modals]))
(defonce grid-entities (r/cursor sale-agreements [:grid-entities]))
(defonce view-settings (r/cursor sale-agreements [:view-settings]))
(defonce sale-agreement-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor sale-agreements [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor sale-agreements [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor sale-agreements [:schema]))
